import { FILTER_FEATURE } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { BaseUserRequestModel } from "app/based/baseApiModel/baseUserModel/BaseUserRequestModel";
import { BaseUserResponseModel } from "app/based/baseApiModel/baseUserModel/BaseUserResponseModel";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { FilterUseCase } from "app/filters/domain/useCase/FilterUseCase";
import { IOTSimRegistrationRequestModel } from "features/iotSimRegistration/data/model/IOTSimRegistrationRequestModel";
import { IOTSimRegistrationResponseModel } from "features/iotSimRegistration/data/model/IOTSimRegistrationResponseModel";
import { IOTSimRegistrationInjection } from "features/iotSimRegistration/di/IOTSimRegistrationInjection";
import { IIOTSimRegistrationRepository } from "features/iotSimRegistration/domain/repositories/IIOTSimRegistrationRepository";
import { injectable } from "tsyringe";

@injectable()
export class IOTSimRegistrationUseCase {
  private iotSimRegistrationRepo: IIOTSimRegistrationRepository;
  private filterUseCase: FilterUseCase;

  constructor() {
    this.iotSimRegistrationRepo =
      IOTSimRegistrationInjection.getIOTSimRegistrationRepo();
    this.filterUseCase = FilterInjection.getUseCase();
  }

  async getList(
    params: IOTSimRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<IOTSimRegistrationResponseModel>> {
    return await this.iotSimRegistrationRepo.getList(params);
  }

  async getDetail(
    params: IOTSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<IOTSimRegistrationResponseModel>> {
    return await this.iotSimRegistrationRepo.getDetail(params);
  }

  async exportReport(
    params: IOTSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    return await this.iotSimRegistrationRepo.exportReport(params);
  }

  async checkStatus(
    code: string,
  ): Promise<BaseApiResponseModel<IOTSimRegistrationResponseModel>> {
    return await this.iotSimRegistrationRepo.checkStatus(code);
  }

  async getFilterList(
    params: BaseFilterListRequestModel,
    target: "carrier" | "partner" | "store" | "denomination" | "package",
  ): Promise<Array<BaseFilterListResponseModel>> {
    let path = "";
    switch (target) {
      case "carrier":
        path = FILTER_FEATURE.CARRIER_LIST;
        break;
      case "partner":
        path = FILTER_FEATURE.PARTNER_LIST;
        break;
      case "store":
        path = FILTER_FEATURE.STORE_LIST;
        break;
      case "denomination":
        path = FILTER_FEATURE.DENOMINATION_LIST;
        break;
      case "package":
        path = FILTER_FEATURE.PACKAGE_LIST;
        break;
    }
    return await this.filterUseCase.fetchListWithFeature({
      path,
      params,
      isNeedFeature: true,
    });
  }

  async getUserForFilter(
    params: BaseUserRequestModel,
    target: "staff" | "userB2B",
  ): Promise<Array<BaseUserResponseModel>> {
    let path = "";
    switch (target) {
      case "staff":
        path = FILTER_FEATURE.STAFF_LIST;
        break;
      case "userB2B":
        path = FILTER_FEATURE.USER_LIST_B2B;
        break;
    }
    return await this.filterUseCase.fetchListWithFeature({
      path,
      params,
      isNeedFeature: true,
    });
  }
}
